import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { process } from "@/config/site";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 65%", "end 60%"],
  });
  const fillHeight = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section data-testid="process-section" className="relative bg-charcoal py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <Reveal className="flex justify-center"><Eyebrow dark>How We Work</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl leading-tight text-white">
              From vision to
              <span className="italic text-champagne"> celebration.</span>
            </h2>
          </Reveal>
        </div>

        <div ref={ref} className="relative pl-14 sm:pl-0">
          {/* track */}
          <div className="absolute left-[22px] sm:left-1/2 top-2 bottom-2 w-px -translate-x-1/2 bg-white/10">
            <motion.div style={{ height: fillHeight }} className="w-full bg-champagne origin-top" />
          </div>

          <div className="space-y-12 sm:space-y-16">
            {process.map((p, i) => {
              const leftSide = i % 2 === 0;
              return (
                <div
                  key={p.step}
                  className={`relative flex sm:items-center ${
                    leftSide ? "sm:flex-row" : "sm:flex-row-reverse"
                  }`}
                >
                  {/* node */}
                  <span className="absolute left-[22px] sm:left-1/2 -translate-x-1/2 z-10 flex h-11 w-11 items-center justify-center rounded-full border border-champagne bg-charcoal font-display text-champagne">
                    {i + 1}
                  </span>

                  <motion.div
                    initial={{ opacity: 0, x: leftSide ? -30 : 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    className={`w-full sm:w-[calc(50%-3rem)] ${
                      leftSide ? "sm:text-right sm:pr-12" : "sm:pl-12"
                    }`}
                  >
                    <h3 className="font-display text-2xl sm:text-3xl text-white">{p.step}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-white/55">{p.desc}</p>
                  </motion.div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
